import { lazy } from 'react';

const VoucherPin = lazy(() => import('./VoucherPin'));

export default VoucherPin;
